<template>

    <v-container>

        <v-sheet height="2" color="transparent">
            <v-progress-linear indeterminate v-if="loading && !nextUrl" color="accent darken-1" height="2"/>
        </v-sheet>

        <v-slide-y-transition>
            <div v-show="!loading">

                <v-card-text class="py-0 mt-4 pt-4">
                    <div class="mt-4 pt-4 text-center" v-if="history.length === 0">
                        <p class="py-4">No se han creado cobros.</p>
                    </div>
                    <v-timeline
                            v-else
                            align-top
                            dense
                    >
                        <div class="mt-4"></div>
                        <template v-for="(history, year) in groups">
                            <h1>{{year}}</h1>
                            <template v-for="(item, i) in history">
                                <v-timeline-item
                                        fill-dot
                                        :icon="item.is_pending ? 'fa-hourglass-half' : 'fa-check'"
                                        :color="item.color"
                                >
                                    <v-card flat
                                            :color="baseColor"
                                            hover @click="showPayment(item)">
                                        <v-card-title class="dark py-1">

                                            <v-layout wrap align-center justify-center>
                                                <v-flex xs12 md2 py-1 my-0>
                                                    <span class="title">${{item.amount | number}}</span>
                                                </v-flex>

                                                <v-flex xs12 md10 text-left text-md-right>
                                                    <small >
                                                        Creado el {{item.human_date_time}}
                                                        <span v-if="item.created_by">por {{item.created_by.first_name}} {{item.created_by.last_name}}</span>
                                                    </small>
                                                </v-flex>


                                            </v-layout>

                                        </v-card-title>

                                        <v-sheet class="pa-2" :color="baseColor">

                                            <text-copier label="Link de pago" :text="item.payment_url"/>


                                            <template v-for="(label, i) in item.labels">
                                                <v-chip
                                                        small
                                                        :style="{border: `1px solid ${label.textColor} !important`}"
                                                        label :color="label.color" :key="i"
                                                ><span :style="{color: label.textColor}">{{label.description}}</span></v-chip>
                                            </template>

                                            <template v-if="item.comments">
                                                <div class="font-weight-bold mt-1">Motivo:</div>
                                                <div :class="baseColor">
                                                    {{item.comments}}
                                                </div>
                                            </template>

                                        </v-sheet>

                                    </v-card>
                                    <v-divider></v-divider>
                                </v-timeline-item>
                            </template>
                        </template>

                    </v-timeline>
                </v-card-text>
            </div>
        </v-slide-y-transition>
        <v-layout wrap>
            <v-flex xs12 text-center>
                <v-btn
                    color="primary"
                    class="px-3"
                    rounded depressed small
                    v-if="nextUrl"
                    @click="getHistory"
                    :loading="loadingMore">Cargar anteriores</v-btn>
            </v-flex>
        </v-layout>
        <create-update-custom-payment ref="editPayment" :payment="paymentToEdit" />
    </v-container>
</template>

<script>
    import {getFakeAvatar} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'
    import CreateUpdateCustomPayment from "../payment/CreateUpdateCustomPayment";
    import TextCopier from "../common/TextCopier";
    import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'


    export default {
        components: {TextCopier, CreateUpdateCustomPayment},
        props: {
            clientId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                dialog: false,
                loading: false,
                loadingMore: false,
                history: [],
                paymentToEdit: null,
                client: null,
                total: 0,
                nextUrl: null
            }
        },
        mounted() {
            const vm = this
            vm.getHistory();
            vm.connectSocket()
        },
        beforeDestroy() {
            const vm = this
            leaveChannel(vm.socket)
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            getFakeAvatar,
            connectSocket(){
                const vm = this
                subscribeToPrivateChannelEvents(vm.socket, {
                    'CustomPaymentUpdated': vm.onPaymentUpdate
                })
            },
            onPaymentUpdate({payment}){
                const vm = this
                const index = vm.history.findIndex(pay => pay.id === payment.id)
                if(index !== -1){
                    vm.history.splice(index,1,payment)
                }
            },
            showPayment(payment) {
                const vm = this
                vm.paymentToEdit = payment
                vm.$nextTick(function(){
                    vm.$refs.editPayment.show()
                })

            },
            async getHistory() {
                var vm = this

                vm.client = null
                const isFirstPage = !vm.nextUrl

                if (vm.loading || vm.loadingMore || !vm.currentProvider || !vm.clientId) return

                if(isFirstPage){
                    vm.loading = true
                }else{
                    vm.loadingMore = true
                }

                let response
                if(!isFirstPage){
                    response = await ApiUtils.makeGet(vm.nextUrl)
                }else{
                    response = await ApiUtils.makeGet(
                        `provider/${vm.currentProvider.id}/payments/custom`,
                        {client_id: vm.clientId}
                    )
                }

                if(isFirstPage){
                    vm.loading = false
                }else{
                    vm.loadingMore = false
                }

                if (!response.ok) {
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error cargando el historial de pagos')
                    return
                }

                const json = await response.json()
                const data = json.result.payments.data
                const prevData = vm.history.length > 0 ?
                    JSON.parse(JSON.stringify(vm.history)) : []




                vm.history = isFirstPage ? data : [
                    ...prevData,
                    ...data
                ]
                vm.total = json.result.payments.total
                vm.nextUrl = json.result.payments.next_page_url

            },
        },
        computed: {
            ...mapState(['currentProvider', 'dark']),
            ...mapState('clientAttention', {
                currentEvent: state => state.currentEvent
            }),
            socket(){
                const vm = this
                return `user.${vm.clientId}.payments`
            },
            blockClass() {
                const vm = this
                let baseClass = 'section py-1 pl-2'
                if (vm.dark) {
                    baseClass += ' white--text secondary lighten-2'
                } else {
                    baseClass += ' black--text grey lighten-3'
                }
                return baseClass
            },
            baseColor() {
                const vm = this
                return vm.dark ? 'secondary' : 'grey lighten-3'
            },
            sessionColor() {
                const vm = this
                return vm.dark ? 'grey lighten-2' : 'secondary darken-1'
            },
            groups() {
                var vm = this
                if (vm.history.length === 0) return []
                const years = vm.history.map(payment => vm.$moment(payment.created_at).format('YYYY'))
                const groups = [...new Set(years)]

                var all = {}

                for (let year in groups) {
                    all[groups[year]] = vm.history
                        .filter(payment => {
                            return vm.$moment(payment.created_at).format('YYYY') === groups[year]
                        }).map(pmt => {
                            var payment = JSON.parse(JSON.stringify(pmt))
                            const datetime =  vm.$moment(payment.created_at)
                            payment.human_date_time = datetime.format('ddd') + ', ' +
                                datetime.format('D') + ' ' +
                                datetime.format('MMMM') + ' a las ' +
                                datetime.format('HH:mm') + 'hrs.'

                            payment.is_pending = pmt.status !== 'done' || pmt.status_detail !== 'normal'
                            payment.color = !payment.is_pending ? 'success' : 'error'

                            return payment
                        })
                }

                return all

            },
            durationUnits() {
                return {
                    'year': 'año(s)',
                    'month': 'mes(es)',
                    'week': 'semana(s)',
                    'day': 'día(s)',
                    'hour': 'hora(s)'
                }
            },
        },
        watch:{
            clientId(){
                const vm = this
                leaveChannel(vm.socket)
                vm.connectSocket()
            }
        }
    }
</script>

<style scoped>

    .indent {
        margin-left: 0
    }

    .total {
        font-family: Roboto, sans-serif;
        font-size: 3em;
        font-weight: 300;
    }
</style>
